import { RefProperty } from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace TimelineActions {
  export class TransitoryFetchTimelineCategories {
    static readonly type = '[CORE_TIMELINE] Fetch Timeline Category';
  }
  export class FetchTimelinePosts {
    static readonly type = '[CORE_TIMELINE] Fetch Timeline Posts';
    constructor(
      public payload: {
        entityIds?: string | string[];
        moduleIds?: string | string[];
        skip: number;
        limit: number;
        replace: boolean;
        postIds?: string[];
        orderByPublishDate?: boolean;
      },
    ) {}
  }

  export class TransitoryFetchTimelinePosts {
    static readonly type = '[CORE_TIMELINE] Transitory Fetch Timeline Posts';
    constructor(
      public payload: {
        entityIds?: string[];
        moduleIds?: string[];
        skip: number;
        limit: number;
        postIds?: string[];
        displayPinnedPosts?: boolean;
        viewId?: string;
        template?: RefProperty;
      },
    ) {}
  }

  export class FetchTimelinePostById {
    static readonly type = '[CORE_TIMELINE] Fetch Timeline Post';
    constructor(
      public payload: {
        id: string;
      },
    ) {}
  }

  export class PinPost {
    static readonly type = '[CORE_TIMELINE] Pin/Unpin Post';
    constructor(
      public payload: {
        id: string;
        isPinned: boolean;
      },
    ) {}
  }
  export class PublishPost {
    static readonly type = '[CORE_TIMELINE] Publish Post';
    constructor(
      public payload: {
        id: string;
        isPublished: boolean;
      },
    ) {}
  }

  export class PublishPostByDate {
    static readonly type = '[CORE_TIMELINE] Publish Post By Date';
    constructor(
      public payload: {
        id: string;
        isPublished: boolean;
        date?: Date;
      },
    ) {}
  }
}
